<template>
  <div class="animated fadeIn">
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $dt('nav.vacations_types_list_title', 'Vacations Types') }}</h4>
            </b-col>
            <b-col md="auto">
              <b-button-group>
                <b-button v-if="!loading" class="mb-3" variant="primary" :to="{ name: 'VacationTypeCreate' }">
                  {{ $t('global.create') }}
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <b-input-group>
                  <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="getData()"><i class="fa fa-search" /></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="auto">
              <b-form-group label-cols :label="$dt('global.per_page', 'Per page:')">
                <b-form-select :options="[2, 10, 20, 40, 60, 100, 500]" v-model="filters.per_page" />
              </b-form-group>
            </b-col>
            <b-col md="auto" v-if="listPaginator.last_page > 1">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
            </b-col>
          </b-row>
          <NoDataView v-if="(!tableItems.length && !(loading))" />
          <b-table v-else class="table-no-padding vacation-types-table table-sm text-center" responsive outlined hover
            head-variant="light" :no-local-sorting=true :sort-by.sync="filters.sort_field" :sort-desc.sync="tableOrder"
            :fields="tableFields" :items="tableItems" :busy="(loading)">
            <template #table-busy>
              <div class="text-center m-2"><b-spinner class="align-middle"></b-spinner></div>
            </template>
            <template v-slot:cell(description)="row">
              <div v-if="row.item.description">
                <div class="description-cell" :id="`description-cell${row.item.id}`">{{ row.item.description }}</div>
                <b-tooltip :target="`description-cell${row.item.id}`" triggers="hover">
                  {{ row.item.description }}
                </b-tooltip>
              </div>
            </template>
            <template v-slot:cell(tickets)="row">
              <span v-for="ticket in row.item.jira_issues" :key="ticket.id">{{ ticket.jira_key }}, </span>
            </template>
            <template v-slot:cell(options)="row">
              <div class="flex-container options-center">
                <router-link v-if="true" :to="{ name: 'VacationTypeUpdate', params: { id: row.item.id } }">
                  <a><i class="mx-1 fa fa-edit fa-lg" /></a>
                </router-link>
                <Delete v-if="true" :id="row.item.id" @deleted="getData" :deleteFn="() => deleteFn(row.item.id)" />
              </div>
            </template>
          </b-table>
          <!--Paginator at bottom-->
          <div v-if="tableItems.length">
            <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Services from '@/services'
import Pagination from 'laravel-vue-pagination'
import Delete from '@/views/Shared/ModalDelete'
import NoDataView from '@/views/Shared/NoDataView.vue'

export default {
  mounted() {
    this.getData()
  },
  components: {
    Pagination, NoDataView, Delete
  },
  props: {
    page: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      tableFields: [
        { key: 'name', sortable: true, label: this.$dt('vacation_type.name', 'Name'), tdClass: 'text-left' },
        { key: 'is_active', sortable: true, label: this.$dt('vacation_type.active', 'Active'), tdClass: 'text-right' },
        { key: 'noteable', sortable: true, label: this.$dt('vacation_type.noteable', 'Noteable'), tdClass: 'text-right' },
        { key: 'tickets', sortable: true, label: this.$dt('vacation_type.tickets', 'Tickets'), tdClass: 'text-right' },
        { key: 'description', sortable: true, label: this.$dt('vacation_type.description', 'Description'), tdClass: 'text-right' },
        { key: 'options', label: this.$dt('global.options', 'Options') }
      ],
      filters: this.parseQuery(),
      list: {},
      errors: {},
      loading: false,
    }
  },
  computed: {
    ...mapState('Auth', ['user']),
    tableItems() {
      return this.list.data || []
    },
    params() {
      return {
        ...this.filters,
      }
    },
    tableOrder: {
      get() { return this.filters.sort_order === 'desc' },
      set(value) {
        this.filters.sort_order = value
          ? 'desc' : 'asc'
      }
    },
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        const hideFromRoute = [] // fixed filters
        this.$router.push({ query: this.uQuery(this.params, hideFromRoute, null, null) })
          .catch(() => { /* redundant navigation exception */ })
      }
    },
    '$route.query'() {
      this.filters = this.parseQuery()
      this.getData()
    },
  },
  methods: {
    getData() {
      this.loading = true
      Services.vacationTypes.list({ params: this.params }).then(({ data }) => {
        this.list = data
        if (this.filters.page !== 1 && data.data.length === 0) this.filters.page = 1 // If filters too strict
      }).catch((errors) => {
        console.log('errors :', errors)
        this.alertError({ title: 'Failed to get vacation types', text: '-' })
      }).finally(() => {
        this.loading = false
      })
    },
    parseQuery() {
      const parsed = {
        page: this.uInt('page', 1, null),
        sort_field: this.uStr('sort_field', 'name', null),
        sort_order: this.uStr('sort_order', 'asc', null),
        per_page: this.uInt('per_page', 20, null),
        search: this.uStr('search', '', null),
      }
      return parsed
    },
    onPageChange(page) {
      this.filters.page = page || 1
      this.getData()
    },
    deleteFn(id) {
      return Services.vacationTypes.delete(id)
    }
  },
}

</script>

<style lang=scss scoped>
th,
td {
  padding: 0;
}

tbody>tr:hover {
  background-color: #c8d2d2;
}

::v-deep .vacation-types-table tr td:nth-child(5) {
  max-width: 100px;
}

.description-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>